/**
 * Removes loading animation once the image has loaded.
 * @param {HTMLElement} elm 
 */
export function updateImage(elm) {
  if (elm.tagName == 'IMG') {
    const source = elm.dataset.src;
    const newImg = new Image();
      
    newImg.onload = () => {
      elm.src = newImg.src;
      elm.classList.remove('loading')
    }
      
    newImg.src = source
  } else {
    elm.src = elm.dataset.src;
    elm.load()
  }
}

/**
 * Formats the date from milliseconds to `mmm dd, yyyy`.
 * @param {number} date
 * @returns {string}
 */
export function formatDate(date) {
  if (date) {
    return new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: 'Africa/Cairo'
    }).format(new Date(date))
  }
  return 'N/A'
}

/**
 * Prevents the element from going to its target.
 * Has a checker to make sure there are no multiple instances of the same event.
 * @param {HTMLElement} elm 
 * @param {function} cb 
 */
export function preventDefault(elm, cb) {
  if (elm.dataset.clickEvent != 'true') {
    elm.dataset.clickEvent = 'true';
    elm.addEventListener('click', (e) => {
      if (cb) {
        cb()
      }
      
      elm.removeAttribute('data-click-event');
      e.preventDefault()
    }, {once: true})
  }
}
